module.exports = __webpack_public_path__ + "static/img/RUC-logo.6b62098.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/RUC-logo.png
// module id = z4D9
// module chunks = 0